import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { Alert } from '@material-ui/lab';

import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import wp from '../../../../assets/svg/logo-webpay.svg';
import { CardContent, CircularProgress, Grid, Divider } from '@material-ui/core';
import { ObtieneEtapasLogic, ObtieneSiguienteEtapaLogic, ObtieneBeneficioAutomaticoLogic } from '../../../view-model/Inicio/PostulacionesEstudiante.logic';
import { UpdateEtapaProcesoLogic } from '../../../view-model/EtapasProceso/EtapasProceso.logic';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core'
import IViewProcesoItemPago from "../../../../presentation/view-interfaces/IViewProcesoItemPago";
import d1 from '../../../../assets/dist/svg/main.svg';

import { ObtieneProcesoItemPagoLogic, ObtienePagoTransbankLogic, ObtieneResultPagoTransbankLogic, InsertarExcepcionLogic, InsertarComprobanteLogic, ObtieneTransferenciaItemPagoLogic, ObtenerDocumentoLogic, ObtenerOCLogic, ObtieneCodComercioLogic } from '../../../view-model/Arancel/Arancel.logic';
import IViewResultPago from '../../../view-interfaces/IViewResultPago';
import IViewEtapas from '../../../view-interfaces/IViewEtapas';
import IViewOCs from '../../../view-interfaces/IViewOCs';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded'
import { DeleteTransferenciaLogic } from '../../../view-model/Transferencia/transferencia.logic';
import { ObtieneProcesoActualLogic, ObtieneBancosLogic, ObtieneCuentasLogic } from '../../../view-model/Parametros/Parametros.logic';
import { con } from "../../../../application/entity/Rutas";
import IViewCombo from "../../../../presentation/view-interfaces/IViewCombo";
import IViewComercio from "../../../../presentation/view-interfaces/IViewComercio";
import InfoComprobantes from '../../../view-model/Modals/InfoComprobantes';
import IViewComprobanteListado from "../../../../presentation/view-interfaces/IViewComprobanteListado";
import { Panel, PanelType } from 'office-ui-fabric-react';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Edit from '@material-ui/icons/Edit'
import Delete from '@material-ui/icons/Delete'

//import ReactTooltip from 'react-tooltip';
import { ObtieneExcepcionLogic, ObtieneExcepcionProgramaLogic, ObtieneTieneFirmaContratoLogic } from '../../../view-model/Contrato/Contrato.logic';
import MensajeToken from '../../../../Components/MensajeToken/MensajeToken';

type Props = { onClickContinuar: any, }
export const Pago: React.FC<Props> = ({ onClickContinuar }) => {
    const history = useHistory();
    const location = useLocation();

    const [codNegocio, setCodNegocio] = useState(0);

    const [idProcesoPostulante, setIdProcesoPostulante] = useState(0);
    const FP: Array<IViewProcesoItemPago> = [];
    const [listaFP, setListaFP] = useState(FP)
    const [montoMatriculaWebPay, setMontoMatriculaWebPay] = useState(0);
    const [montoMatriculaTransferencia, setMontoMatriculaTransferencia] = useState(0);
    const [montoAceptadoMatriculaTransferencia, setMontoAceptadoMatriculaTransferencia] = useState(0);

    const [montoArancelWebPay, setMontoArancelWebPay] = useState(0);
    const [montoArancelTransferencia, setMontoArancelTransferencia] = useState(0);
    const [montoAceptadoArancelTransferencia, setMontoAceptadoArancelTransferencia] = useState(0);
    const [montoPagoContado, setMontoPagoContado] = useState(0);

    const [btnArancel, setbtnArancel] = useState(false)
    const [btnArancelTB, setbtnArancelTB] = useState(false)
    const [btnMatricula, setbtnMatricula] = useState(false)
    const [btnMatriculaTB, setbtnMatriculaTB] = useState(false)
    const listaEtapas: Array<IViewEtapas> = [];
    const [etapas, setEtapas] = useState(listaEtapas);
    const [cargandoValores, setCargandoValores] = useState(true)

    const [pagandoMatricula, setPagandoMatricula] = useState(false)
    const [pagandoArancel, setPagandoArancel] = useState(false)
    const [error, setError] = useState(false)
    const [reintentar, setReintentar] = useState(false)

    const [anioActual, setAnioActual] = useState(0)
    const [periodoActual, setPeriodoActual] = useState(0)

    const [openModalArchivos, setOpenModalArchivos] = useState(false)

    const listaBancos: any = [];
    const [bancos, setBancos] = useState(listaBancos);
    const listaCuentas: any = [];
    const [cuentas, setCuentas] = useState(listaCuentas);

    const [errorTransbank, setErrorTransbank] = useState(false)
    const [idComprobante, setIdComprobante] = useState(0)
    const [guidComprobante, setGuidComprobante] = useState('')
    const [idProcesoItemPagoMatricula, setIdProcesoItemPagoMatricula] = useState(0)
    const [idProcesoItemPagoArancel, setIdProcesoItemPagoArancel] = useState(0)
    const [idProcesoItemPago, setIdProcesoItemPago] = useState(0)

    const [subiendoDocMatricula, setSubiendoDocMatricula] = useState(false)
    const [subiendoDocArancel, setSubiendoDocArancel] = useState(false)

    const [estadoRechazadoMatricula, setEstadoRechazadoMatricula] = useState(false)
    const [estadoRechazadoArancel, setEstadoRechazadoArancel] = useState(false)

    const [errorSubirDocMatricula, setErrorSubirDocMatricula] = useState(false)
    const [mnsjSubirDocMatricula, setMnsjSubirDocMatricula] = useState('')
    const [errorSubirDocArancel, setErrorSubirDocArancel] = useState(false)
    const [mnsjSubirDocArancel, setMnsjSubirDocArancel] = useState('')

    const [sumaTransferenciasMatricula, setSumaTransferenciasMatricula] = useState(0)
    const [sumaTransferenciasArancel, setSumaTransferenciasArancel] = useState(0)

    const [openCuentasTransferencias, setOpenCuentasTransferencias] = useState(false)

    const [esDeposito, setEsDeposito] = useState(false)

    const [errorDoc, setErrorDoc] = useState(false)

    const [montoManualPagoArancel, setMontoManualPagoArancel] = useState(0)
    const [errorMontoManualArancel, setErrorMontoManualArancel] = useState(false)
    const [mnsjErrorMontoArancel, setMnsjErrorMontoArancel] = useState("")
    const [montoManualPagoMatricula, setMontoManualPagoMatricula] = useState(0)
    const [errorMontoManualMatricula, setErrorMontoManualMatricula] = useState(false)
    const [mnsjErrorMontoMatricula, setMnsjErrorMontoMatricula] = useState("")

    const listaOcs: Array<IViewOCs> = [];
    const [listadoOCMatricula, setListadoOCMatricula] = useState(listaOcs);
    const [listadoOCArancel, setListadoOCArancel] = useState(listaOcs);

    const [sumaOCMatricula, setSumaOCMatricula] = useState(0)
    const [sumaOCArancel, setSumaOCArancel] = useState(0)

    const [cargandoOCArancel, setCargandoOCArancel] = useState(true)
    const [cargandoOCMatricula, setCargandoOCMatricula] = useState(true)
    const [debeFirmar, setDebeFirmar] = useState(true);

    const [transDelete, setTransDelete] = useState(false);

    useEffect(() => {
        if (reintentar) {
            setError(false)
            if (location.state === null || location.state === undefined) {
                history.push({
                    pathname: "/Inicio"
                });
            } else {
                handleCargaDatosIniciales();
            }
            setReintentar(false)
        }
    }, [reintentar])
    const result: Array<IViewResultPago> = [
        {
            idOCWebplay: 0,
            amount: 0,
            status: '',
            buyOrden: '',
            transactionDate: '',
            authorizationCode: '',
            responseCode: 0,
            ResponseDescription: ''
        }
    ];
    const [resultPago, setResultPago] = useState(result)
    const [openModal, setOpenModal] = useState(false)
    const listComprob: Array<IViewComprobanteListado> = []
    const [listadoComprobanteMatricula, setListadoComprobanteMatricula] = useState(listComprob)
    const [listadoComprobanteArancel, setListadoComprobanteArancel] = useState(listComprob)

    const [openModalEliminarArancel, setOpenModalEliminarArancel] = useState(false)
    const [openModalEliminarMatricula, setOpenModalEliminarMatricula] = useState(false)

    const [errorVentanasEmergentes, setErrorVentanasEmergentes] = useState(false)

    const [saldoFaltante, setSaldoFaltante] = useState(0)

    const [tienePagoMatricula, setTienePagoMatricula] = useState(false)
    const [tienePagoArancel, setTienePagoArancel] = useState(false)
    const _listaComercio: IViewComercio[] = [];
    const [listaComercioArancel, setListaComercioArancel] = useState(_listaComercio)
    const [listaComercioMatricula, setListaComercioMatricula] = useState(_listaComercio)
    const [openCodComercioMatricula, setOpenCodComercioMatricula] = useState(false)
    const [openCodComercioArancel, setOpenCodComercioArancel] = useState(false)

    //const [codComercio, setCodComercio] = useState(0)
    const [codComercioMatricula, setCodComercioMatricula] = useState(0)
    const [codComercioArancel, setCodComercioArancel] = useState(0)
    const [tipoPago, setTipoPago] = useState(0)

    const [pagar, setPagar] = useState(false)
    const [tieneExcepcion, setTieneExcepcion] = useState(false)
    const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })

    useEffect(() => {
        if (location.state === null || location.state === undefined) {
            history.push({
                pathname: "/Inicio"
            });
        } else {
            sessionStorage.setItem('fase', JSON.stringify('pago'))
            ObtieneBancosLogic(selListaBancoActual)
            ObtieneCuentasLogic(selListaCuentaActual)
            handleCargaDatosIniciales();
            ObtieneProcesoActualLogic(selListaProcesoActual)
        }
    }, [])
    useEffect(() => {
        if (anioActual > 0 && periodoActual > 0)
            ObtenerOC()
    }, [anioActual, periodoActual])

    useEffect(() => {
        if (btnArancel && btnMatricula && (btnMatriculaTB && ((montoMatriculaTransferencia - montoAceptadoMatriculaTransferencia) === 0)) && (btnArancelTB && ((montoArancelTransferencia - montoAceptadoArancelTransferencia) === 0))) {
            UpdateEtapaProceso()
        }
    }, [btnArancel, btnMatricula, btnMatriculaTB, btnArancelTB, montoAceptadoArancelTransferencia, montoAceptadoMatriculaTransferencia, montoMatriculaTransferencia, montoArancelTransferencia])

    const selListaBancoActual = (error: Boolean, err: string, data: IViewCombo[]) => {
        try {
            if (error === false) {
                /* console.log(data) */
                let nuevo: any[] = []
                data.map((e: IViewCombo) => {
                    nuevo.push({ key: e.ID, text: e.descripcion })
                })
                setBancos(nuevo)
            }
        } catch (err) {
            console.log('error', err)
        }
    }
    const selListaCuentaActual = (error: Boolean, err: string, data: IViewCombo[]) => {
        try {
            if (error === false) {
                /* console.log(data) */
                let nuevo: any[] = []
                data.map((e: IViewCombo) => {
                    nuevo.push({ key: e.ID, text: e.descripcion })
                })
                setCuentas(nuevo)
            }
        } catch (err) {
            console.log('error', err)
        }
    }
    const selListaProcesoActual = (error: Boolean, err: string, data: any) => {
        try {
            if (error === false) {
                //let _tt = JSON.stringify(location.state, ["rut"]);
                //let _rut = JSON.parse(_tt)
                /* console.log(data) */
                setPeriodoActual(parseInt(data.periodo))
                setAnioActual(data.ano)

            }
        } catch (err) {
            console.log('error', err)
        }
    }

    const InsertarExcepcion = () => {
        let _cod = con.codExceptionTransferencia();
        let codTipoExcepcion = _cod.split(',')[0]
        let codExcepcion = _cod.split(',')[1]
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)

        InsertarExcepcionLogic(selExcepcion, _params.rut, _params.codCarrera, anioActual, periodoActual, parseInt(codTipoExcepcion), parseInt(codExcepcion), _params.codigoNegocio)
    }

    const ObtenerOC = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        ObtenerOCLogic(selOCs, _params.rut, Number(_params.idProceso))
    }
    const selExcepcion = (error: Boolean, err: string, result: any) => {
        try {
            if (error === false) {
                console.log(result)
                onClickContinuar("3")
            }
        } catch (err) {
            console.log('error', err)
        }
    }
    const selOCs = (error: Boolean, err: string, result: any) => {
        try {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt)
            var arancel_aux: Array<IViewOCs> = [];
            var matricula_aux: Array<IViewOCs> = [];
            var _sumaOCMatricula = 0;
            var _sumaOCArancel = 0;

            if (error === false) {
                /* console.log(result) */
                result.map((e: any) => {
                    if (e.programa === _params.codCarrera && e.anio === anioActual && e.periodo === periodoActual && e.item === "ARANCEL" && e.estado === 'PAGADA') {
                        _sumaOCArancel = _sumaOCArancel + e.monto;
                        arancel_aux.push({
                            estado: e.estado === 'PAGADA',
                            fecha: e.fecha,
                            monto: e.monto
                        })
                    }
                    if (e.programa === _params.codCarrera && e.anio === anioActual && e.periodo === periodoActual && e.item === "MATRICULA" && e.estado === 'PAGADA') {
                        _sumaOCMatricula = _sumaOCMatricula + e.monto;
                        matricula_aux.push({
                            estado: e.estado === 'PAGADA',
                            fecha: e.fecha,
                            monto: e.monto
                        })
                    }
                })
                setListadoOCMatricula(matricula_aux);
                setListadoOCArancel(arancel_aux);
                setSumaOCArancel(_sumaOCArancel);
                setSumaOCMatricula(_sumaOCMatricula);

                setCargandoOCArancel(false)
                setCargandoOCMatricula(false)
            }
        } catch (err) {
            console.log('error', err)
            setCargandoOCArancel(false)
            setCargandoOCMatricula(false)
        }
    }
    const onFormatFate = (date: string) => {
        var fecha = new Date(date);
        return `${fecha.getDate().toString().length > 1 ? fecha.getDate() : '0' + fecha.getDate()}-${fecha.getMonth().toString().length > 1 ? fecha.getMonth() + 1 : '0' + (fecha.getMonth() + 1)}-${fecha.getFullYear()} ${fecha.getHours().toString().length > 1 ? fecha.getHours() : '0' + fecha.getHours()}:${fecha.getMinutes().toString().length > 1 ? fecha.getMinutes() : '0' + fecha.getMinutes()}`
    }

    const handleCargaDatosIniciales = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        /* console.log(_params) */
        let _cod = con.codExceptionTransferencia();
        //let codTipoExcepcion = _cod.split(',')[0]
        let codExcepcion = _cod.split(',')[1]
        ObtieneExcepcionLogic(selResultadoExcepcion, parseInt(_params.rut!.toString()), parseInt(codExcepcion), _params.codigoNegocio, 0, 0, _params.codCarrera);

        setCodNegocio(_params.codigoNegocio)
        //setDebeFirmar(_params.debeFirmar)
        //Actualiza la información si debe firmar contrato
        if (!_params.debeFirmar) {
            ObtieneTieneFirmaContratoLogic(selListaFirma, _params.codigoNegocio, _params.rut, _params.codCarrera, _params.anioPromocion, _params.periodoPromocion, _params.codigoPlanificacionAcademica);
        }

        setIdProcesoPostulante(Number(_params.idProceso))
        setCargandoValores(true)
        ObtieneEtapasLogic(selListaEtapas, _params.codigoNegocio, _params.codCarrera, _params.codigoPlanificacionAcademica, _params.rut, _params.anioPromocion, _params.periodoPromocion);
        setTimeout(() => {
            ObtieneProcesoItemPagoLogic(selObtenerFormaPago, _params.headers, _params.idProceso)
        }, 2000);
        //ObtieneBeneficioAutomaticoLogic(selObtieneBeneficioAutomatico, _params.codigoNegocio, _params.codCarrera)
        ObtieneCodComercioLogic(selObtenerComercioMatricula, _params.codigoNegocio, _params.codCarrera, 20)
        ObtieneCodComercioLogic(selObtenerComercioArancel, _params.codigoNegocio, _params.codCarrera, 21)
    }

    const selResultadoExcepcion = (error: Boolean, err: string, Resultado: any) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        let _cod = con.codExceptionTransferencia();

        let codExcepcion = _cod.split(',')[1]
        try {
            if (Resultado) {
                setTieneExcepcion(Resultado)
            } else {
                ObtieneExcepcionProgramaLogic(selResultadoExcepcionPrograma, parseInt(codExcepcion), _params.codigoNegocio, _params.codCarrera, _params.anioPromocion, _params.periodoPromocion, _params.codigoPlanificacionAcademica);
            }
        } catch (err) {
            console.log('error', err)
        }
    }

    const selResultadoExcepcionPrograma = (error: Boolean, err: string, Resultado: any) => {
        try {
            setTieneExcepcion(Resultado)
        } catch (err) {
            console.log('error', err)
        }
    }

    const selListaFirma = (error: Boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            console.log("PAGO resultado firmar");
            console.log(data);
            setDebeFirmar(data);
        }
    }

    const selObtenerComercioMatricula = (error: Boolean, err: string, result: IViewComercio[]) => {
        if (error === false) {
            if (result.length > 0) {
                //setCodComercio(result[0].codComercio)
                setCodComercioMatricula(result[0].codComercio)
            }
            console.log(result);
            setListaComercioMatricula(result)
        } else {
        }
    }

    const selObtenerComercioArancel = (error: Boolean, err: string, result: IViewComercio[]) => {
        if (error === false) {
            if (result.length > 0) {
                //setCodComercio(result[0].codComercio)
                setCodComercioArancel(result[0].codComercio)
            }
            console.log(result);
            setListaComercioArancel(result)
        } else {
        }
    }
    const selResultadoPagoTransbank = (error: Boolean, err: string, Resultado: IViewResultPago[]) => {
        try {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt)
            // if (error === false) {
            /* if (Resultado.length > 0) { */
            /* setPagandoArancel(false)
            setPagandoMatricula(false) */
            /* } */
            // }
            setPagandoArancel(false)
            setPagandoMatricula(false)
            setResultPago(Resultado)
            if (Resultado.length > 0) {
                setErrorTransbank(Resultado[0].status !== 'AUTHORIZED')
            } else {
                setErrorTransbank(true)
            }
            setOpenModal(true)
            ObtieneProcesoItemPagoLogic(selObtenerFormaPago, _params.headers, idProcesoPostulante)
        } catch (err) {
            console.log('error', err)
        }
        setMontoManualPagoArancel(0)
        setMontoManualPagoMatricula(0)
        setCargandoOCArancel(true)
        setCargandoOCMatricula(true)
        ObtenerOC()
    }
    const selResultadoPagoTransbankMatricula = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false) {
                setPagandoMatricula(true)
                // setNoAbrir(false)
                // setCantRepet(0)
                // setmyhtmlMatricula(Resultado.url)
                // setTokenMatricula(Resultado.token)

                let windowName = 'w_' + Date.now() + Math.floor(Math.random() * 100000).toString();
                var form = document.createElement("form");
                form.setAttribute("method", "post");
                form.setAttribute("action", Resultado.url);

                form.setAttribute("target", windowName);

                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", "token_ws");
                hiddenField.setAttribute("value", Resultado.token);
                form.appendChild(hiddenField);
                document.body.appendChild(form);

                var respuesta = window.open('', windowName);
                var timer = setInterval(function () {
                    try {
                        if (respuesta!.closed) {
                            setTimeout(() => {
                                //ObtieneResultPagoTransbankLogic(selResultadoPagoTransbank, Resultado.token, "", con.codMatricula(), codComercio)
                                ObtieneResultPagoTransbankLogic(selResultadoPagoTransbank, Resultado.token, "", con.codMatricula(), codComercioMatricula)
                            }, 3000);
                            clearInterval(timer);
                        }
                    }
                    catch (e: any) {
                        setErrorVentanasEmergentes(true)
                    }
                }, 500);

                form.submit();
            }
            setTimeout(() => {
                //setCargandoWebPayMatricula(false)
            }, 1000);

        } catch (err) {
            console.log('error', err)
        }
    }

    const selResultadoPagoTransbankArancel = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false) {
                setPagandoArancel(true)
                // setNoAbrir(false)
                // setCantRepet(0)
                // setmyhtmlArancel(Resultado.url)
                // setTokenArancel(Resultado.token)
                let windowName = 'w_' + Date.now() + Math.floor(Math.random() * 100000).toString();
                var form = document.createElement("form");
                form.setAttribute("method", "post");
                form.setAttribute("action", Resultado.url);

                form.setAttribute("target", windowName);

                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", "token_ws");
                hiddenField.setAttribute("value", Resultado.token);
                form.appendChild(hiddenField);
                document.body.appendChild(form);

                var respuesta = window.open('', windowName);
                var timer = setInterval(function () {
                    try {
                        if (respuesta!.closed) {
                            setTimeout(() => {
                                //ObtieneResultPagoTransbankLogic(selResultadoPagoTransbank, Resultado.token, "", con.codArancel(), codComercio)
                                ObtieneResultPagoTransbankLogic(selResultadoPagoTransbank, Resultado.token, "", con.codArancel(), codComercioArancel)

                            }, 3000);
                            clearInterval(timer);
                        }
                    }
                    catch (e: any) {
                        setErrorVentanasEmergentes(true)
                    }
                }, 500);
                form.submit();
            }
            setTimeout(() => {
                // setCargandoWebPayArancel(false)
            }, 1000);
        } catch (err) {
            console.log('error', err)
        }
    }

    // const selObtieneBeneficioAutomatico = (error: Boolean, err: string, Resultado: any) => {
    //     try {
    //         if (error === false) {
    //            // setBeneficioAutomatico(Resultado)
    //             //Resultado.map((e: any) => {
    //                 //setPorcentajeAutomatico(parseFloat(e.arancel))
    //             //})
    //             /* console.log(Resultado) */
    //         }
    //     } catch (err) {
    //         console.log('error', err)
    //     }
    // }


    const selObtenerFormaPago = (error: Boolean, err: string, result: IViewProcesoItemPago[]) => {
        let tieneTBMatricula = false;
        let tieneTBArancel = false;
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        if (error === false) {
            /* console.log(result) */
            setListaFP(result)
            let countMatricula = 0
            let countArancel = 0
            if (result.length > 0) {
                //setbtnArancelTB(true)
                //setbtnMatriculaTB(true)
                result.map((e: IViewProcesoItemPago) => {
                    if (!e.esBeca && e.codigoItem === 20) {
                        //console.log(e);
                        if (e.formaPago === 84) {
                            setTienePagoMatricula(true)
                            countMatricula = countMatricula + 1
                            setMontoMatriculaWebPay(Math.round(e.montoClp))
                            setbtnMatricula(e.montoClp === 0 ? true : e.pagado)
                        } else if (e.formaPago === con.codTransferencia()) {
                            tieneTBMatricula = true
                            setTienePagoMatricula(true)
                            setIdProcesoItemPagoMatricula(e.idProcesoItemPago)
                            if (e.idProcesoItemPago > 0) {
                                ObtieneTransferenciaItemPagoLogic(selListaComprobantesMatricula, _params.headers, e.idProcesoItemPago)
                            }
                            setMontoMatriculaTransferencia(Math.round(e.montoClp))
                            setEsDeposito(true)
                        }
                    }
                    if (!e.esBeca && e.codigoItem === 21) {
                        //console.log(e);
                        if (e.formaPago === 84) {
                            setTienePagoArancel(true);
                            countArancel = countArancel + 1;
                            setMontoArancelWebPay(Math.round(e.montoClp));
                            setbtnArancel(e.montoClp === 0 ? true : e.pagado);
                        } else if (e.formaPago === con.codTransferencia()) {
                            tieneTBArancel = true;
                            setTienePagoArancel(true);
                            setIdProcesoItemPagoArancel(e.idProcesoItemPago);
                            if (e.idProcesoItemPago > 0) {
                                ObtieneTransferenciaItemPagoLogic(selListaComprobantesArancel, _params.headers, e.idProcesoItemPago);
                            }
                            setMontoArancelTransferencia(Math.round(e.montoClp));
                        }
                    }

                    if (e.esBeca && e.codigoItem === 21) {
                        if (e.formaPago === 110 || e.formaPago === 106) {
                            setMontoPagoContado(Math.round(e.montoClp));
                        }
                    }
                });

                if (countMatricula === 0) {
                    setbtnMatricula(true)
                    //setbtnMatriculaTB(true)
                }
                if (countArancel === 0) {
                    setbtnArancel(true)
                    //setbtnArancelTB(true)
                }

                setbtnMatriculaTB(!tieneTBMatricula)
                setbtnArancelTB(!tieneTBArancel)
            }
            setCargandoValores(false)
        } else {
            if (err != "500") {
                setOpenModalToken({ open: true, mnsj: err })
            } else {
                setError(true)
            }
        }
    }
    const selListaComprobantesMatricula = (error: Boolean, err: string, result: IViewComprobanteListado[]) => {
        //let pagadoTotal = 0;
        //let pagadoInd = 0;
        if (error === false) {
            console.log(result)
            setListadoComprobanteMatricula(result)
            let estadoRechazada = false;
            let estadoAceptada = false;
            //let estadoPendiente = false;
            result.map((e: IViewComprobanteListado) => {
                //pagadoTotal = e.montoTotal;
                //pagadoInd = pagadoInd + e.montoPagado; 
                estadoRechazada = e.idEstado === con.idEstadoRechazadaComprobante() ? true : false
                estadoAceptada = e.idEstado === con.idEstadoAceptadaComprobante() ? true : false
                //estadoPendiente = e.idEstado === con.idEstadoInicialComprobante() ? true : false
            })
            setEstadoRechazadoMatricula(estadoRechazada)
            setbtnMatriculaTB(estadoAceptada)
            //setbtnMatriculaTB(!estadoRechazada && estadoAceptada && !estadoPendiente && (pagadoInd == pagadoTotal))
        } else {
            if (err != "500") {
                setOpenModalToken({ open: true, mnsj: err })
            }
        }
    }
    const selListaComprobantesArancel = (error: Boolean, err: string, result: IViewComprobanteListado[]) => {
        //let pagadoTotal = 0;
        //let pagadoInd = 0;
        if (error === false) {
            setListadoComprobanteArancel(result)
            let estadoRechazada = false;
            let estadoAceptada = false;
            //let estadoPendiente = false;
            result.map((e: IViewComprobanteListado) => {
                //pagadoTotal = e.montoTotal;
                //pagadoInd = pagadoInd + e.montoPagado; 
                estadoRechazada = e.idEstado === con.idEstadoRechazadaComprobante() ? true : false
                estadoAceptada = e.idEstado === con.idEstadoAceptadaComprobante() ? true : false
                //estadoPendiente = e.idEstado === con.idEstadoInicialComprobante() ? true : false
            })
            setEstadoRechazadoArancel(estadoRechazada)
            setbtnArancelTB(estadoAceptada)
            //setbtnMatriculaTB(!estadoRechazada && estadoAceptada && !estadoPendiente && (pagadoInd == pagadoTotal))
        } else {
            if (err != "500") {
                setOpenModalToken({ open: true, mnsj: err })
            }
        }
    }

    useEffect(() => {
        if (pagar) {
            if (tipoPago === 1) {
                transbankMatricula()
            } else if (tipoPago === 2) {
                transbankManualMatricula()
            } else if (tipoPago === 3) {
                transbankArancel()
            } else if (tipoPago === 4) {
                transbankManualArancel()
            }
        }
    }, [tipoPago, pagar])

    const transbankMatricula = () => {
        console.log(codComercioMatricula);
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        if (montoMatriculaWebPay > 0) {
            // setCargandoWebPayMatricula(true)
            // setCodigoItem(20)
            //ObtienePagoTransbankLogic(selResultadoPagoTransbankMatricula, _params.idProceso, 20, Math.round(montoMatriculaWebPay), codComercio)
            ObtienePagoTransbankLogic(selResultadoPagoTransbankMatricula, _params.idProceso, 20, Math.round(montoMatriculaWebPay), codComercioMatricula)
        }
        setTipoPago(0)
        setPagar(false)
    }
    const transbankManualMatricula = () => {
        console.log(codComercioMatricula);
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        if (montoMatriculaWebPay > 0) {
            // setCargandoWebPayMatricula(true)
            // setCodigoItem(20)
            //ObtienePagoTransbankLogic(selResultadoPagoTransbankMatricula, _params.idProceso, 20, montoManualPagoMatricula, codComercio)
            ObtienePagoTransbankLogic(selResultadoPagoTransbankMatricula, _params.idProceso, 20, montoManualPagoMatricula, codComercioMatricula)
        }
        setTipoPago(0)
        setPagar(false)
    }
    const transbankArancel = () => {
        console.log(codComercioArancel);
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        if (montoArancelWebPay > 0) {
            // setCargandoWebPayArancel(true)
            // setCodigoItem(21)
            //ObtienePagoTransbankLogic(selResultadoPagoTransbankArancel, _params.idProceso, 21, Math.round(montoArancelWebPay), codComercio)
            ObtienePagoTransbankLogic(selResultadoPagoTransbankArancel, _params.idProceso, 21, Math.round(montoArancelWebPay), codComercioArancel)
        }
        setTipoPago(0)
        setPagar(false)
    }
    const transbankManualArancel = () => {
        console.log(codComercioArancel);
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        if (montoArancelWebPay > 0) {
            // setCargandoWebPayArancel(true)
            // setCodigoItem(21)
            //ObtienePagoTransbankLogic(selResultadoPagoTransbankArancel, _params.idProceso, 21, montoManualPagoArancel, codComercio)
            ObtienePagoTransbankLogic(selResultadoPagoTransbankArancel, _params.idProceso, 21, montoManualPagoArancel, codComercioArancel)
        }
        setTipoPago(0)
        setPagar(false)
    }
    const selListaEtapas = (error: Boolean, err: string, Etapas: any) => {
        if (error === false && Etapas !== undefined) {
            setEtapas(Etapas)
            Etapas.map((e: any) => {
                // if (e.idEtapa === 4) {
                //     setValidado(e.estado)
                // }
            })
            var contrato: boolean = false;
            var pago: boolean = false;
            /* console.log(etapas) */
            Etapas.map((e: IViewEtapas) => {
                if (e.nombre === 'Pago Web-Pay') {
                    pago = e.estado
                }
                if (e.nombre === "Contrato") {
                    contrato = e.estado
                }
            })

            ObtieneSiguienteEtapaLogic(selSiguienteEtapa, contrato, false);
        }
    }
    const UpdateEtapaProceso = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        /* console.log(_params) */

        //if (_params.debeFirmar) {
        if (debeFirmar) {
            if (codNegocio === 1) {
                UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 4);
                onClickContinuar("5")
            } else if (codNegocio === 2) {
                if (_params.rut !== _params.rutRF) {
                    UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 4);
                    onClickContinuar("5")
                } else {
                    UpdateEtapaProcesoLogic(selUpdateEtapaPostgradoSinRF, idProcesoPostulante, 4, true);
                }
            } else if (codNegocio === 3) {
                UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 4);
                onClickContinuar("5")
                /*  setTimeout(() => {
                         UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 5);
                         onClickContinuar("5")
                 }, 2000); */
            }
        }
        else {
            UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 5);
            UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 6);
            onClickContinuar("7")
        }
        // if (codNegocio === 1) {
        //     UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 4);
        //     onClickContinuar("5")
        // } else if (codNegocio === 2) {
        //     if (_params.rut !== _params.rutRF) {
        //         UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 4);
        //         onClickContinuar("5")
        //     } else {
        //         UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 4);
        //         UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 5);
        //         setTimeout(() => {
        //             onClickContinuar("6")
        //         }, 2000);
        //     }
        // } else if (codNegocio === 3) {
        //     UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 4);
        //     setTimeout(() => {
        //         if (_params.debeFirmar) {
        //             UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 5);
        //             onClickContinuar("5")
        //         }
        //         else {
        //             UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 5);
        //             UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 6);
        //             onClickContinuar("7")
        //         }
        //     }, 2000);
        // }
    }
    function transformarMiles(valor: string) {
        const valor1 = valor + "";
        let retornar = "0";
        var splitValor;
        if (valor !== "0") {
            if (valor1.indexOf('.') === -1) {
                retornar = parseInt(valor1).toLocaleString()
            } else {
                splitValor = valor1.split('.');
                retornar = parseInt(splitValor[0]).toLocaleString()
            }
        }
        return retornar;
    }
    const selUpdateEtapa = (error: Boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            /* let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt)
            if (codNegocio === 1) {
                onClickContinuar("5")
            } */
        }
    }
    const selUpdateEtapaPostgradoSinRF = (error: Boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            /* UpdateEtapaProcesoLogic(selUpdateEtapaPostgradoCerrarCarga, idProcesoPostulante, 5); */
            onClickContinuar("6")
        }
    }
    /* const selUpdateEtapaPostgradoCerrarCarga = (error: Boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            onClickContinuar("6")
        }
    } */
    const selSiguienteEtapa = (error: Boolean, err: string, Sig: any) => {
        if (error === false && Sig !== undefined) {
            /* console.log(Sig); */
            // setSigEtapa(Sig.idEtapa.toString())

            /* UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante,1); */

        }
    }
    const siguienteEtapa = () => {
        var contrato: boolean = false;
        var pago: boolean = false;
        /* console.log(etapas) */
        etapas.map((e: IViewEtapas) => {
            if (e.nombre === 'Pago Web-Pay') {
                pago = e.estado
            }
            if (e.nombre === "Contrato") {
                contrato = e.estado
            }
        })

        ObtieneSiguienteEtapaLogic(selSiguienteEtapa, contrato, true);
    }
    const getBase64 = (file: any) => {
        return new Promise(resolve => {
            let fileInfo;
            let baseURL = "";
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result !== null ? reader.result.toString() : '';
                resolve(baseURL);
            };
        });
    };
    const handleFileInputChangeMatricula = (e: any) => {
        setErrorSubirDocMatricula(false)
        setSubiendoDocMatricula(true)
        setIdProcesoItemPago(idProcesoItemPagoMatricula)
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        // let array_aux: Array<IViewComprobanteTranferencia> = [];
        /* console.log(e.target.files[0]); */
        let file: any;

        file = e.target.files[0];
        let extension = file.type.split('/')[1];

        getBase64(file)
            .then(result => {
                file["base64"] = result;

                // let fecha = new Date()
                // let idDocumento_aux = (parseInt(e.target.name.split('/')[1]))
                if (extension === 'pdf' || extension === 'PDF' || extension === 'jpg' || extension === 'JPG' || extension === 'jpeg' || extension === 'JPEG') {
                    if (file.size < 6000000) {
                        InsertarComprobanteLogic(selInsertComprobanteMatricula, _params.rut, _params.codCarrera, 0, 0, file.base64.split('base64,')[1], "MATWEB", (extension === 'jpeg' || extension === 'JPEG' ? 'jpg' : extension), _params.codigoNegocio, _params.codigoPlanificacionAcademica, _params.idPeriodo, _params.idPersona)
                    } else {
                        setSubiendoDocMatricula(false)
                        setErrorSubirDocMatricula(true)
                        setMnsjSubirDocMatricula("El archivo debe tener un tamaño máximo de 6mb (6.000Kb)")
                    }
                } else {
                    setSubiendoDocMatricula(false)
                    setErrorSubirDocMatricula(true)
                    setMnsjSubirDocMatricula("Formato del documento solo puede ser PDF o JPG")
                }
            })
            .catch(err => {
                console.log(err);
            })

    }
    const selInsertComprobanteMatricula = (error: Boolean, err: string, result: any) => {
        if (error === false && result !== undefined) {
            /* console.log(result) */
            setGuidComprobante(result)
            if (result.length > 0) {
                setSaldoFaltante(montoMatriculaTransferencia - sumaTransferenciasMatricula)
                setIdComprobante(0)
                setOpenModalArchivos(true)
                setSubiendoDocMatricula(false)
                setSubiendoDocArancel(false)
            } else {
                setErrorSubirDocMatricula(true)
                setMnsjSubirDocMatricula("Se ha producido un error al intentar cargar el documento.")
            }
        } else {
            setSubiendoDocMatricula(false)
            setSubiendoDocArancel(false)
            setErrorSubirDocMatricula(true)
            setMnsjSubirDocMatricula("Se ha producido un error al intentar cargar el documento.")
        }
    }
    const selInsertComprobanteArancel = (error: Boolean, err: string, result: any) => {
        if (error === false && result !== undefined) {
            console.log(result)
            setGuidComprobante(result)
            if (result.length > 0) {
                setSaldoFaltante(((montoArancelTransferencia) - sumaTransferenciasArancel))
                setIdComprobante(0)
                setOpenModalArchivos(true)
                setSubiendoDocMatricula(false)
                setSubiendoDocArancel(false)
            } else {
                setErrorSubirDocArancel(true)
                setMnsjSubirDocArancel("Se ha producido un error al intentar cargar el documento.")
            }
        } else {
            setSubiendoDocMatricula(false)
            setSubiendoDocArancel(false)
            setErrorSubirDocArancel(true)
            setMnsjSubirDocArancel("Se ha producido un error al intentar cargar el documento.")
        }
    }
    const handleFileInputChangeArancel = (e: any) => {
        setErrorSubirDocArancel(false)
        setSubiendoDocArancel(true)
        setIdProcesoItemPago(idProcesoItemPagoArancel)
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        // let array_aux: Array<IViewComprobanteTranferencia> = [];
        console.log(e.target.files[0]);
        let file: any;

        file = e.target.files[0];
        let extension = file.type.split('/')[1];

        getBase64(file)
            .then(result => {
                file["base64"] = result;

                // let fecha = new Date()
                // let idDocumento_aux = (parseInt(e.target.name.split('/')[1]))
                if (extension === 'pdf' || extension === 'PDF' || extension === 'jpg' || extension === 'JPG' || extension === 'jpeg' || extension === 'JPEG') {
                    if (file.size < 6000000) {
                        InsertarComprobanteLogic(selInsertComprobanteArancel, _params.rut, _params.codCarrera, 0, 0, file.base64.split('base64,')[1], "MATWEB", (extension === 'jpeg' || extension === 'JPEG' ? 'jpg' : extension), _params.codigoNegocio, _params.codigoPlanificacionAcademica, _params.idPeriodo, _params.idPersona)
                    } else {
                        setSubiendoDocArancel(false)
                        setErrorSubirDocArancel(true)
                        setMnsjSubirDocArancel("El archivo debe tener un tamaño máximo de 6mb (6.000Kb)")
                    }
                } else {
                    setSubiendoDocArancel(false)
                    setErrorSubirDocArancel(true)
                    setMnsjSubirDocArancel("Formato del documento solo puede ser PDF o JPG")
                }
            })
            .catch(err => {
                console.log(err);
            })

    }
    useEffect(() => {
        let suma = 0
        let sumaAceptada = 0
        if (listadoComprobanteMatricula.length > 0) {
            listadoComprobanteMatricula.map((e: IViewComprobanteListado) => {
                if (e.idEstado != con.idEstadoRechazadaComprobante()) {
                    suma = suma + e.montoPagado
                }
                if (e.idEstado == con.idEstadoAceptadaComprobante()) {
                    sumaAceptada = sumaAceptada + e.montoPagado
                }
            })
        }
        setMontoAceptadoMatriculaTransferencia(Math.round(sumaAceptada))
        setSumaTransferenciasMatricula(Math.round(suma))

    }, [listadoComprobanteMatricula])
    useEffect(() => {
        let suma = 0
        let sumaAceptada = 0
        if (listadoComprobanteArancel.length > 0) {
            listadoComprobanteArancel.map((e: IViewComprobanteListado) => {
                if (e.idEstado != con.idEstadoRechazadaComprobante()) {
                    suma = suma + e.montoPagado
                }
                if (e.idEstado == con.idEstadoAceptadaComprobante()) {
                    sumaAceptada = sumaAceptada + e.montoPagado
                }
            })
        }
        setMontoAceptadoArancelTransferencia(Math.round(sumaAceptada))
        setSumaTransferenciasArancel(Math.round(suma))
    }, [listadoComprobanteArancel])

    const handleDeleteArancel = () => {
        DeleteTransferenciaLogic(selDeleteComprobanteArancel, idComprobante)
    }
    const selDeleteComprobanteArancel = (error: Boolean, err: string, result: any) => {
        setIdComprobante(0)
        setOpenModalEliminarArancel(false)
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        if (idProcesoItemPagoArancel > 0) {
            ObtieneTransferenciaItemPagoLogic(selListaComprobantesArancel, _params.headers, idProcesoItemPagoArancel)
        }
        /* setListadoComprobanteArancel(listComprob) */
        if (error === false && result !== undefined) {
            setEstadoRechazadoArancel(false);

            setTransDelete(true);
        }
    }
    const selDeleteComprobanteMatricula = (error: Boolean, err: string, result: any) => {
        setIdComprobante(0)
        setOpenModalEliminarMatricula(false)
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        if (idProcesoItemPagoMatricula > 0) {
            ObtieneTransferenciaItemPagoLogic(selListaComprobantesMatricula, _params.headers, idProcesoItemPagoMatricula)
        }
        if (error === false && result !== undefined) {
            setEstadoRechazadoMatricula(false)

            setTransDelete(true);
        }
    }
    const handleDeleteMatricula = () => {
        DeleteTransferenciaLogic(selDeleteComprobanteMatricula, idComprobante)
    }
    const onClickModal = (cambio: boolean = false) => {
        setOpenModalArchivos(cambio)
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        if (idProcesoItemPagoMatricula > 0) {
            ObtieneTransferenciaItemPagoLogic(selListaComprobantesMatricula, _params.headers, idProcesoItemPagoMatricula)
        }
        if (idProcesoItemPagoArancel > 0) {
            ObtieneTransferenciaItemPagoLogic(selListaComprobantesArancel, _params.headers, idProcesoItemPagoArancel)
        }
    }
    const handleVerDocumento = (guid: string) => {
        //setCargandoContrato(true)
        ObtenerDocumentoLogic(selDownloadDoc, guid)
    }
    const selDownloadDoc = (error: Boolean, err: string, result: any) => {
        if (error === false) {
            setErrorDoc(result.length === 0)
        } else {
            setErrorDoc(true)
        }
        // setCargandoContrato(false)
    }
    const validarMontoArancel = (montoManual: number) => {
        console.log(montoManual)
        console.log(montoArancelWebPay)
        if (montoManual <= Math.round((montoArancelWebPay - sumaOCArancel))) {
            setErrorMontoManualArancel(false)
            setMontoManualPagoArancel(montoManual)
        } else {
            setErrorMontoManualArancel(true)
            setMnsjErrorMontoArancel("El monto ingresado supera el monto total del Arancel")
            setMontoManualPagoArancel(montoManual)
        }
    }
    const validarMontoMatricula = (montoManual: number) => {
        console.log(montoManual)
        console.log(montoMatriculaWebPay)
        if (montoManual <= montoMatriculaWebPay) {
            setErrorMontoManualMatricula(false)
            setMontoManualPagoMatricula(montoManual)
        } else {
            setErrorMontoManualMatricula(true)
            setMnsjErrorMontoMatricula("El monto ingresado supera el monto total de la Matrícula")
            setMontoManualPagoMatricula(montoManual)
        }
    }
    const format = (num: number) => {
        const n = String(num),
            p = n.indexOf('.')
        return n.replace(
            /\d(?=(?:\d{3})+(?:\.|$))/g,
            (m, i) => p < 0 || i < p ? `${m}.` : m
        )
    }

    const refrescar = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        if (_params.codigoNegocio == 1) {
            history.push({
                pathname: "/matricula",
                state: {
                    'rut': _params.rut,
                    'codCarrera': _params.codCarrera,
                    'codigoNegocio': 1,
                    'codigoPlanificacionAcademica': _params.codigoPlanificacionAcademica,
                    'codsede': _params.codsede,
                    'nombreCarrera': _params.nombreCarrera,
                    'nombreAlumno': _params.nombreAlumno,
                    'numeroAlumno': _params.numeroAlumno,
                    'anioPromocion': _params.anioPromocion,
                    'periodoPromocion': _params.periodoPromocion,
                    'idProceso': _params.idProceso,
                    'menu': "4"
                }
            })

            window.location.reload()
        } else {
            history.push({
                pathname: "/matricula",
                state: {
                    'rut': _params.rut,
                    'codCarrera': _params.codCarrera,
                    'codigoNegocio': _params.codigoNegocio,
                    'codigoPlanificacionAcademica': _params.codigoPlanificacionAcademica,
                    'codsede': _params.codsede,
                    'nombreCarrera': _params.nombreCarrera,
                    'numeroAlumno': _params.numeroAlumno,
                    'anioPromocion': _params.anioPromocion,
                    'periodoPromocion': _params.periodoPromocion,
                    'idProceso': _params.idProceso,
                    'menu': "4",
                    'codComercio': _params.codComercio,
                    'rutRF': _params.rutRF,
                    'debeFirmar': debeFirmar,
                    'idPersona': _params.idPersona
                }
            })

            window.location.reload()
        }
    }

    return (
        <>
            {
                error ?
                    <div className="site-main__container">
                        <div style={{ marginBottom: '2rem', color: 'gray', fontSize: '1rem' }}>
                            <div className="enrollment__subtitle"></div>
                        </div>
                        <div style={{ textAlign: 'center', marginTop: 100 }}>

                            <ErrorOutlineRounded style={{ fontSize: 50, color: 'red' }} />
                            <br />
                            <a><span>Ocurrió un problema al obtener tus pagos, favor comunicarse con la universidad.</span></a>
                            <br />
                            <Button style={{ border: '1px solid gray' }} onClick={() => setReintentar(true)} color="inherit">Reintentar cargar pagos</Button>
                        </div>
                    </div>
                    :
                    <main className="site-main enrollment">
                        {cargandoValores ?
                            <div className="site-main__container">
                                <div style={{ textAlign: 'center', marginTop: 100 }}>

                                    <CircularProgress disableShrink />
                                    <br />
                                    <a><span>Cargando datos</span></a>

                                </div>
                            </div>
                            :
                            <div className="site-main__container">
                                {
                                    esDeposito ?
                                        <button onClick={() => setOpenCuentasTransferencias(true)} style={{ float: 'right' }} className="btn btn-primary" id="btn-submit-enrollment-tariff" type="submit">Cuenta Transferencia</button>
                                        :
                                        ""
                                }
                                <div style={{ marginTop: '-3rem', marginBottom: '1rem' }} >
                                    <div style={{ fontSize: '1rem' }}>
                                        {/* <div style={{ display: 'list-item' }} className="enrollment__subtitle">A continuación deberás pagar las opciones seleccionadas anteriormente:</div> */}
                                        <div className="enrollment__subtitle">Si su elección fue Webpay, considerar:</div>
                                        <div style={{ display: 'list-item', marginLeft: '2rem' }} className="enrollment__subtitle">Para utilizar sólo una tarjeta seleccione PAGO TOTAL.</div>
                                        <div style={{ display: 'list-item', marginLeft: '2rem' }} className="enrollment__subtitle">Para utilizar más de una tarjeta, ingrese el monto a pagar y seleccione Webpay, realizado el pago será redireccionado nuevamente a esta página donde podrá cancelar el saldo con otra tarjeta.</div>
                                    </div>
                                </div>
                                <div className="payment-webpay">
                                    <div className="payment-webpay__enrollment">
                                        {
                                            tienePagoMatricula ?
                                                <>
                                                    <h3 className="payment-webpay__title">Pago matrícula</h3>
                                                    <p className="payment-webpay__description">Has seleccionado pagar la Matrícula por Webpay y/o Transferencia Bancaria: </p>
                                                </>
                                                :
                                                ""
                                        }
                                        {listaFP.map((e: IViewProcesoItemPago) => {
                                            if (!e.esBeca && e.codigoItem === 20) {
                                                if (e.formaPago === 84) {
                                                    if (e.montoClp > 0) {
                                                        return (
                                                            <div className="">
                                                                <div className="payment-webpay__summary">
                                                                    <Grid container direction="column">
                                                                        <Grid container item xs={12} sm={6} md={6} direction="row" /* justifyContent="center" alignItems="stretch" */>
                                                                            <div>
                                                                                <Grid container>
                                                                                    <Grid item xs={12} sm={6} md={6}>
                                                                                        <table className="payment-webpay__table table">
                                                                                            <thead>
                                                                                                <tr>
                                                                                                    <th className="payment-webpay__item-title">A pagar (CLP)</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    <td className="payment-webpay__item" data-th="A pagar (CLP)"><span className="payment-webpay__item-value">$ {transformarMiles(e.montoClp.toString())}</span></td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </Grid>
                                                                                    <Grid item xs={12} sm={6} md={6}>
                                                                                        {
                                                                                            cargandoOCMatricula ?
                                                                                                <div className="site-main__container">
                                                                                                    <div style={{ textAlign: 'center', marginTop: 100 }}>

                                                                                                        <CircularProgress disableShrink />
                                                                                                        <br />
                                                                                                        <a><span>Cargando datos</span></a>

                                                                                                    </div>
                                                                                                </div>
                                                                                                :
                                                                                                <div className="payment-webpay__action">
                                                                                                    <table className="table" style={{ marginTop: -10 }}>
                                                                                                        {
                                                                                                            btnMatricula ?
                                                                                                                ""
                                                                                                                :
                                                                                                                <>
                                                                                                                    <thead>
                                                                                                                        <tr>
                                                                                                                            <th className="payment-webpay__item-title"> </th>
                                                                                                                            <th className="payment-webpay__item-title" style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>Monto a Pagar</th>
                                                                                                                            <th className="payment-webpay__item-title" style={{ textAlign: 'center' }}>Pago</th>
                                                                                                                        </tr>
                                                                                                                    </thead>
                                                                                                                    <tbody>
                                                                                                                        {
                                                                                                                            listadoOCMatricula.length > 0 ?
                                                                                                                                ""
                                                                                                                                :
                                                                                                                                <tr>
                                                                                                                                    <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap' }}>Pago total</td>
                                                                                                                                    <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap', textAlign: 'center' }}><span className="payment-webpay__item-value">$ {transformarMiles(Math.round((e.montoClp)).toString())}</span></td>
                                                                                                                                    <td>

                                                                                                                                        <button disabled={btnMatricula}
                                                                                                                                            onClick={() => {
                                                                                                                                                if (codNegocio !== 1) {
                                                                                                                                                    if (listaComercioMatricula.length > 1) {
                                                                                                                                                        setOpenCodComercioMatricula(true)
                                                                                                                                                        setTipoPago(1)
                                                                                                                                                    } else {
                                                                                                                                                        transbankMatricula()
                                                                                                                                                    }
                                                                                                                                                } else {
                                                                                                                                                    transbankMatricula()
                                                                                                                                                }
                                                                                                                                                /* */
                                                                                                                                            }}
                                                                                                                                            className="btn btn-primary payment-webpay__btn-pay"
                                                                                                                                            id="btn-pay-tariff"
                                                                                                                                            style={{ background: 'white' }}
                                                                                                                                            type="submit">
                                                                                                                                            {btnMatricula ? "Pagado" : <img src={wp} alt="Logo Web Pay" className="payment-webpay__logo" />}
                                                                                                                                        </button>

                                                                                                                                    </td>
                                                                                                                                </tr>
                                                                                                                        }
                                                                                                                        <tr>
                                                                                                                            <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap' }}>Monto</td>
                                                                                                                            <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap', textAlign: 'center', alignItems: 'center' }}>
                                                                                                                                <input id="monto"
                                                                                                                                    name="monto"
                                                                                                                                    style={{ width: '100%', textAlign: 'center' }}
                                                                                                                                    className="form-control js-will-validate"
                                                                                                                                    type="text"
                                                                                                                                    onChange={(e: any) => {
                                                                                                                                        if (parseInt(e.target.value.replaceAll('.', '')) >= 0) {
                                                                                                                                            validarMontoMatricula(parseInt(e.target.value.replaceAll('.', '')))
                                                                                                                                        }

                                                                                                                                    }
                                                                                                                                    }
                                                                                                                                    value={format(parseInt(montoManualPagoMatricula.toString()))}
                                                                                                                                    disabled={btnMatricula}

                                                                                                                                />
                                                                                                                            </td>
                                                                                                                            <td>
                                                                                                                                {
                                                                                                                                    /* montoManualPagoMatricula > 0 ? */
                                                                                                                                    <button disabled={btnMatricula ? true : errorMontoManualMatricula ? true : (montoManualPagoMatricula > 0 && montoManualPagoMatricula <= (montoMatriculaWebPay - sumaOCMatricula)) ? false : true}
                                                                                                                                        onClick={() => {
                                                                                                                                            if (codNegocio !== 1) {
                                                                                                                                                if (listaComercioMatricula.length > 1) {
                                                                                                                                                    setOpenCodComercioMatricula(true)
                                                                                                                                                    setTipoPago(2)
                                                                                                                                                } else {
                                                                                                                                                    transbankManualMatricula()
                                                                                                                                                }
                                                                                                                                            } else {
                                                                                                                                                transbankManualMatricula()
                                                                                                                                            }
                                                                                                                                            /* () */
                                                                                                                                        }}
                                                                                                                                        className="btn btn-primary payment-webpay__btn-pay"
                                                                                                                                        style={{ background: 'white' }}
                                                                                                                                        id="btn-pay-tariff"
                                                                                                                                        type="submit">
                                                                                                                                        {/* {btnMatricula ? "Pagado" : "Pagar Matricula"} */} <img src={wp} alt="Logo Web Pay" className="payment-webpay__logo" />
                                                                                                                                    </button>
                                                                                                                                    /* :
                                                                                                                                    "" */
                                                                                                                                }


                                                                                                                            </td>
                                                                                                                        </tr>
                                                                                                                        <tr>
                                                                                                                            <td></td>
                                                                                                                            <td></td>
                                                                                                                            <td></td>
                                                                                                                        </tr>
                                                                                                                    </tbody>
                                                                                                                </>
                                                                                                        }
                                                                                                        {
                                                                                                            listadoOCMatricula.length > 0 ?
                                                                                                                <thead>
                                                                                                                    <tr>
                                                                                                                        <th className="payment-webpay__item-title"> </th>
                                                                                                                        <th className="payment-webpay__item-title" style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>Monto Pagado</th>
                                                                                                                        <th className="payment-webpay__item-title" style={{ textAlign: 'center' }}>Fecha Pago</th>
                                                                                                                    </tr>
                                                                                                                </thead>
                                                                                                                :
                                                                                                                ""
                                                                                                        }
                                                                                                        <tbody>
                                                                                                            {
                                                                                                                listadoOCMatricula.map((e: IViewOCs) => {
                                                                                                                    return (
                                                                                                                        <tr>
                                                                                                                            <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap' }}></td>
                                                                                                                            <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap', textAlign: 'center' }}><span className="payment-webpay__item-value">$ {transformarMiles(Math.round((e.monto)).toString())}</span></td>

                                                                                                                            <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                                                                                                                                {
                                                                                                                                    onFormatFate((e.fecha).toString().substr(0, 16))
                                                                                                                                }


                                                                                                                            </td>
                                                                                                                        </tr>
                                                                                                                    )
                                                                                                                })
                                                                                                            }
                                                                                                        </tbody>
                                                                                                        {
                                                                                                            listadoOCMatricula.length > 0 ?
                                                                                                                listadoOCMatricula.length === 1 && btnMatricula ?
                                                                                                                    ""
                                                                                                                    :
                                                                                                                    <tfoot>
                                                                                                                        <tr>
                                                                                                                            <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap' }}>Suma</td>
                                                                                                                            <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap', textAlign: 'center' }}><span className="payment-webpay__item-value">$ {transformarMiles(Math.round((sumaOCMatricula)).toString())}</span></td>

                                                                                                                        </tr>
                                                                                                                        <tr>
                                                                                                                            <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap' }}>Faltante</td>
                                                                                                                            <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap', textAlign: 'center' }}><span className="payment-webpay__item-value">$ {transformarMiles(Math.round((montoMatriculaWebPay - sumaOCMatricula)).toString())}</span></td>

                                                                                                                        </tr>
                                                                                                                    </tfoot>
                                                                                                                :
                                                                                                                ""
                                                                                                        }

                                                                                                    </table>



                                                                                                    {
                                                                                                        errorMontoManualMatricula ?
                                                                                                            <Alert variant="outlined" severity="error">{mnsjErrorMontoMatricula} </Alert>
                                                                                                            :
                                                                                                            ""
                                                                                                    }
                                                                                                    {
                                                                                                        btnMatricula && (btnMatriculaTB && ((montoMatriculaTransferencia - montoAceptadoMatriculaTransferencia) === 0)) ?
                                                                                                            <Alert style={{ width: '15rem' }} variant="outlined"
                                                                                                                /* icon={<CheckIcon fontSize="inherit" />} */
                                                                                                                iconMapping={{
                                                                                                                    info: <CheckCircleOutline fontSize="inherit" />,
                                                                                                                }}
                                                                                                                severity="info">Matrícula Pagada</Alert>
                                                                                                            :
                                                                                                            ""
                                                                                                    }
                                                                                                </div>
                                                                                        }

                                                                                    </Grid>
                                                                                </Grid>
                                                                            </div>

                                                                        </Grid>
                                                                    </Grid>

                                                                    {/* <div className="payment-webpay__action">
                                                                        <button disabled={btnMatricula}
                                                                            onClick={() => {
                                                                                transbankMatricula()

                                                                            }} className="btn btn-primary payment-webpay__btn-pay" id="btn-pay-enrollment" type="submit">{btnMatricula ? "Pagado" : "Pagar matrícula"}</button>
                                                                        <img src={wp} alt="Logo Web Pay" className="payment-webpay__logo" />
                                                                    </div> */}

                                                                </div>
                                                                {
                                                                    !btnMatricula ?
                                                                        errorTransbank ?
                                                                            !tieneExcepcion ?
                                                                                <div>
                                                                                    <br /><br />
                                                                                    <a onClick={() => InsertarExcepcion()} style={{ cursor: 'pointer' }} className="enrollment__back"><svg className="svg-chevron-left-dims"><use xlinkHref={d1 + "#chevron-right"}></use></svg> Cambiar a pago por Transferencia Bancaria</a>
                                                                                </div>
                                                                                :
                                                                                ""
                                                                            :
                                                                            ""
                                                                        :
                                                                        ""
                                                                }

                                                            </div>
                                                        )
                                                    }
                                                } else if (e.formaPago === con.codTransferencia()) {
                                                    if (e.montoClp > 0) {
                                                        return (
                                                            <div className="">
                                                                {/* !btnMatriculaTB &&  */ ((montoMatriculaTransferencia - montoAceptadoMatriculaTransferencia) > 0) ?
                                                                    <div className="payment-webpay__summary">
                                                                        <table className="payment-webpay__table table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th className="payment-webpay__item-title">A pagar (CLP)</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="payment-webpay__item" data-th="A pagar (CLP)"><span className="payment-webpay__item-value">$ {transformarMiles(e.montoClp.toString())}</span></td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                        {
                                                                            subiendoDocMatricula ?
                                                                                <div style={{ display: 'contents' }}>
                                                                                    <CircularProgress disableShrink size={30} /> <p style={{ marginTop: 10 }}> &nbsp;&nbsp;&nbsp;&nbsp;Subiendo Comprobante</p>
                                                                                </div>
                                                                                :
                                                                                <>
                                                                                    <div className="file-select" id="src-file1">
                                                                                        <input
                                                                                            aria-label="Archivo"
                                                                                            type="file"
                                                                                            style={{ width: '100%', fontSize: '1rem', cursor: 'pointer' }}
                                                                                            onChange={handleFileInputChangeMatricula}
                                                                                        />
                                                                                    </div>

                                                                                </>
                                                                        }
                                                                        {
                                                                            errorSubirDocMatricula ?
                                                                                <>
                                                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                                                    <Alert variant="outlined" severity="error"> {mnsjSubirDocMatricula} </Alert>
                                                                                </>
                                                                                :
                                                                                ""
                                                                        }
                                                                    </div>
                                                                    : ""}
                                                                <br />
                                                                <div className="payment-webpay__action">
                                                                    <div style={{ float: 'right' }}></div>
                                                                    {
                                                                        sumaTransferenciasMatricula > 0 ?
                                                                            <table className={"payment-selection__table table"}>
                                                                                <thead>
                                                                                    <th className='text-center'>Valor total</th>
                                                                                    <th className='text-center'>Valor transferido</th>
                                                                                    <th className='text-center'>Saldo faltante</th>
                                                                                </thead>
                                                                                <tfoot>
                                                                                    <tr>
                                                                                        <td className='text-center'>{`$${transformarMiles((montoMatriculaTransferencia).toString())}`}</td>
                                                                                        <td className='text-center'>{`$${transformarMiles(sumaTransferenciasMatricula.toString())}`}</td>
                                                                                        <td className='text-center'>{`$${transformarMiles((montoMatriculaTransferencia - sumaTransferenciasMatricula).toString())}`}</td>
                                                                                    </tr>
                                                                                </tfoot>
                                                                            </table>
                                                                            :
                                                                            ""
                                                                    }

                                                                    {/* <button style={{ background: '#ab4343', border: '1px solid #ab4343', float: 'right', marginBottom: 15 }} onClick={() => setOpenModalEliminarMatricula(true)} hidden={!estadoRechazadoMatricula} className="btn btn-primary" id="btn-submit-enrollment-tariff" type="submit">Eliminar Comprobantes</button> */}

                                                                    <Grid container item xs={12} sm={12} md={12} direction="column" >
                                                                        <CardContent>
                                                                            <Grid container direction="row"  >
                                                                                {listadoComprobanteMatricula.map((e: IViewComprobanteListado, i: any) => {
                                                                                    return (
                                                                                        <div className={"rounded"} style={{ border: "1px solid #0062a1", padding: 20, marginBottom: 10, marginRight: 10, backgroundColor: 'rgb(246 251 255)' }}>
                                                                                            <Grid item xs={6} sm={6} md={6} direction="column">
                                                                                                <p className="" style={{ inlineSize: 'fit-content', width: '15rem' }}>
                                                                                                    <h4 className="card-title text-center font-weight-bold noWrap" style={{ height: 50 }}>{e.nombreEstado}</h4>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-left font-weight-normal">Rut: </span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{`${e.rutTitular}-${e.dvTitular}`}</strong></span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal">Nombre</span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{e.nombreTitular}</strong></span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal">N° Transacción</span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{e.numTransaccion}</strong></span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal">Banco</span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{e.nombreBanco}</strong></span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal">Tipo Cuenta</span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{e.nombreTipoCuenta}</strong></span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal">Monto</span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{`$${transformarMiles(e.montoPagado.toString())}`}</strong></span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal">Observación</span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{e.observacion === "" ? "-" : e.observacion}</strong></span>
                                                                                                    <br></br>
                                                                                                    {/* <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><button onClick={() => handleVerDocumento(e.guidHQB)} className="btn btn-primary" id="btn-submit-enrollment-tariff" type="submit" disabled={cargandoContrato}> {cargandoContrato ? <CircularProgress color="inherit" size={20} disableShrink /> : "Ver Adjunto"}</button></span>
                                                                                                    <br></br> */}
                                                                                                    {
                                                                                                        e.idEstado != 2 ?
                                                                                                            <span style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                                                                                                                <button
                                                                                                                    style={{ background: '#0062a1', border: '1px solid #0062a1', width: '7rem' }}
                                                                                                                    onClick={() => {
                                                                                                                        setIdProcesoItemPago(e.idProcesoItemPago)
                                                                                                                        setIdComprobante(e.idTransferencia)
                                                                                                                        setTimeout(() => {
                                                                                                                            setOpenModalArchivos(true)
                                                                                                                        }, 1000)
                                                                                                                    }}
                                                                                                                    className="btn btn-primary"
                                                                                                                    id="btn-submit-enrollment-tariff"
                                                                                                                    type="submit"><Edit fontSize="inherit" />Editar
                                                                                                                </button>

                                                                                                                <button
                                                                                                                    style={{ background: '#ab4343', border: '1px solid #ab4343', width: '7rem' }}
                                                                                                                    onClick={() => {
                                                                                                                        setIdComprobante(e.idTransferencia)
                                                                                                                        setOpenModalEliminarMatricula(true)
                                                                                                                    }}
                                                                                                                    className="btn btn-primary"
                                                                                                                    id="btn-submit-enrollment-tariff"
                                                                                                                    type="submit"><Delete fontSize="inherit" />Eliminar
                                                                                                                </button>
                                                                                                            </span>
                                                                                                            :
                                                                                                            ""
                                                                                                    }

                                                                                                </p>
                                                                                            </Grid>
                                                                                        </div>
                                                                                    )
                                                                                }
                                                                                )
                                                                                }
                                                                            </Grid>
                                                                        </CardContent>
                                                                    </Grid>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                }
                                            }
                                        })}
                                    </div>
                                    <div className="payment-webpay__tariff">
                                        {
                                            tienePagoArancel ?
                                                <>
                                                    <h3 className="payment-webpay__title">Pago Arancel</h3>
                                                    <p className="payment-webpay__description">Has seleccionado pagar el Arancel por Webpay y/o Transferencia Bancaria: </p>
                                                </>
                                                :
                                                ""
                                        }

                                        {listaFP.map((e: IViewProcesoItemPago) => {
                                            if (!e.esBeca && e.codigoItem === 21) {
                                                if (e.formaPago === 84) {
                                                    if (e.montoClp > 0) {
                                                        return (
                                                            <div className="">
                                                                <div className="payment-webpay__summary">
                                                                    <table className="payment-webpay__table table">
                                                                        <thead>
                                                                            <tr>
                                                                                {
                                                                                    montoPagoContado > 0 ?
                                                                                        <>
                                                                                            <th className="payment-webpay__item-title">Valor en pesos (CLP)</th>
                                                                                            <th className="payment-webpay__item-title">Descuento pago al contado (CLP)</th>
                                                                                        </>
                                                                                        :
                                                                                        ""
                                                                                }

                                                                                <th className="payment-webpay__item-title">A pagar (CLP)</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                {
                                                                                    montoPagoContado > 0 ?
                                                                                        <>
                                                                                            <td className="payment-webpay__item" data-th="Valor en pesos (CLP)"><span className="payment-webpay__item-value">$ {transformarMiles((Math.round(e.montoClp) + montoPagoContado).toString())}</span></td>
                                                                                            <td className="payment-webpay__item" data-th="Descuento pago al contado (CLP)"><span className="payment-webpay__item-value">{`$${transformarMiles(montoPagoContado.toString())}`}</span></td>
                                                                                        </>
                                                                                        :
                                                                                        ""
                                                                                }
                                                                                <td className="payment-webpay__item" data-th="A pagar (CLP)"><span className="payment-webpay__item-value">$ {transformarMiles(Math.round((e.montoClp)).toString())}</span></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    {
                                                                        cargandoOCArancel ?
                                                                            <div className="site-main__container">
                                                                                <div style={{ textAlign: 'center', marginTop: 100 }}>

                                                                                    <CircularProgress disableShrink />
                                                                                    <br />
                                                                                    <a><span>Cargando datos</span></a>

                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            <div className="payment-webpay__action">
                                                                                {/*  <button disabled={btnArancel}
                                                                            onClick={() => {
                                                                                transbankArancel()
                                                                            }}
                                                                            className="btn btn-primary payment-webpay__btn-pay"
                                                                            id="btn-pay-tariff"
                                                                            type="submit">
                                                                            {btnArancel ? "Pagado" : "Pagar arancel"}
                                                                        </button>
                                                                        <img src={wp} alt="Logo Web Pay" className="payment-webpay__logo" />
 */}

                                                                                <table className="table" style={{ marginTop: -10 }}>
                                                                                    {
                                                                                        btnArancel ?
                                                                                            ""
                                                                                            :
                                                                                            <>
                                                                                                <thead>
                                                                                                    <tr>
                                                                                                        <th className="payment-webpay__item-title"> </th>
                                                                                                        <th className="payment-webpay__item-title" style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>Monto a Pagar</th>
                                                                                                        <th className="payment-webpay__item-title" style={{ textAlign: 'center' }}>Pago</th>
                                                                                                    </tr>
                                                                                                </thead>
                                                                                                <tbody>
                                                                                                    {
                                                                                                        listadoOCArancel.length > 0 ?
                                                                                                            ""
                                                                                                            :
                                                                                                            <tr>
                                                                                                                <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap' }}>Pago total</td>
                                                                                                                <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap', textAlign: 'center' }}><span className="payment-webpay__item-value">$ {transformarMiles(Math.round((e.montoClp)).toString())}</span></td>
                                                                                                                <td>

                                                                                                                    <button disabled={btnArancel}
                                                                                                                        onClick={() => {
                                                                                                                            if (codNegocio !== 1) {
                                                                                                                                if (listaComercioArancel.length > 1) {
                                                                                                                                    setOpenCodComercioArancel(true)
                                                                                                                                    setTipoPago(3)
                                                                                                                                } else {
                                                                                                                                    transbankArancel()
                                                                                                                                }
                                                                                                                            } else {
                                                                                                                                transbankArancel()
                                                                                                                            }
                                                                                                                            /* () */
                                                                                                                        }}
                                                                                                                        className="btn btn-primary payment-webpay__btn-pay"
                                                                                                                        id="btn-pay-tariff"
                                                                                                                        style={{ background: 'white' }}
                                                                                                                        type="submit">
                                                                                                                        {btnArancel ? "Pagado" : <img src={wp} alt="Logo Web Pay" className="payment-webpay__logo" />}
                                                                                                                    </button>

                                                                                                                </td>
                                                                                                            </tr>
                                                                                                    }
                                                                                                    <tr>
                                                                                                        <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap' }}>Monto</td>
                                                                                                        <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap', textAlign: 'center', alignItems: 'center' }}>
                                                                                                            <input id="monto"
                                                                                                                name="monto"
                                                                                                                style={{ width: '100%', textAlign: 'center' }}
                                                                                                                className="form-control js-will-validate"
                                                                                                                type="text"
                                                                                                                onChange={(e: any) => {
                                                                                                                    if (parseInt(e.target.value.replaceAll('.', '')) >= 0) {
                                                                                                                        validarMontoArancel(parseInt(e.target.value.replaceAll('.', '')))
                                                                                                                    }

                                                                                                                }
                                                                                                                }
                                                                                                                value={format(parseInt(montoManualPagoArancel.toString()))}
                                                                                                                disabled={btnArancel}

                                                                                                            />
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            {
                                                                                                                /* montoManualPagoArancel > 0 ? */
                                                                                                                <button disabled={btnArancel ? true : errorMontoManualArancel ? true : (montoManualPagoArancel > 0 && montoManualPagoArancel <= (montoArancelWebPay - sumaOCArancel)) ? false : true}
                                                                                                                    onClick={() => {
                                                                                                                        if (codNegocio !== 1) {
                                                                                                                            if (listaComercioArancel.length > 1) {
                                                                                                                                setOpenCodComercioArancel(true)
                                                                                                                                setTipoPago(4)
                                                                                                                            } else {
                                                                                                                                transbankManualArancel()
                                                                                                                            }
                                                                                                                        } else {
                                                                                                                            transbankManualArancel()
                                                                                                                        }
                                                                                                                        /* () */
                                                                                                                    }}
                                                                                                                    className="btn btn-primary payment-webpay__btn-pay"
                                                                                                                    style={{ background: 'white' }}
                                                                                                                    id="btn-pay-tariff"
                                                                                                                    type="submit">
                                                                                                                    {/* {btnArancel ? "Pagado" : "Pagar arancel"} */} <img src={wp} alt="Logo Web Pay" className="payment-webpay__logo" />
                                                                                                                </button>
                                                                                                                /* :
                                                                                                                "" */
                                                                                                            }


                                                                                                        </td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td></td>
                                                                                                        <td></td>
                                                                                                        <td></td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            </>
                                                                                    }
                                                                                    {
                                                                                        listadoOCArancel.length > 0 ?
                                                                                            <thead>
                                                                                                <tr>
                                                                                                    <th className="payment-webpay__item-title"> </th>
                                                                                                    <th className="payment-webpay__item-title" style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>Monto Pagado</th>
                                                                                                    <th className="payment-webpay__item-title" style={{ textAlign: 'center' }}>Fecha Pago</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            :
                                                                                            ""
                                                                                    }

                                                                                    <tbody>
                                                                                        {
                                                                                            listadoOCArancel.map((e: IViewOCs) => {
                                                                                                return (
                                                                                                    <tr>
                                                                                                        <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap' }}></td>
                                                                                                        <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap', textAlign: 'center' }}><span className="payment-webpay__item-value">$ {transformarMiles(Math.round((e.monto)).toString())}</span></td>

                                                                                                        <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                                                                                                            {
                                                                                                                onFormatFate((e.fecha).toString().substr(0, 16))
                                                                                                            }


                                                                                                        </td>
                                                                                                    </tr>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </tbody>
                                                                                    {
                                                                                        listadoOCArancel.length > 0 ?
                                                                                            listadoOCArancel.length === 1 && btnArancel ?
                                                                                                ""
                                                                                                :
                                                                                                <tfoot>
                                                                                                    <tr>
                                                                                                        <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap' }}>Suma</td>
                                                                                                        <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap', textAlign: 'center' }}><span className="payment-webpay__item-value">$ {transformarMiles(Math.round((sumaOCArancel)).toString())}</span></td>

                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap' }}>Faltante</td>
                                                                                                        <td className="payment-webpay__item" style={{ whiteSpace: 'nowrap', textAlign: 'center' }}><span className="payment-webpay__item-value">$ {transformarMiles(Math.round((montoArancelWebPay - sumaOCArancel)).toString())}</span></td>

                                                                                                    </tr>
                                                                                                </tfoot>
                                                                                            :
                                                                                            ""
                                                                                    }

                                                                                </table>



                                                                                {
                                                                                    errorMontoManualArancel ?
                                                                                        <Alert variant="outlined" severity="error">{mnsjErrorMontoArancel} </Alert>
                                                                                        :
                                                                                        ""
                                                                                }
                                                                                {
                                                                                    btnArancel && (btnArancelTB && ((montoArancelTransferencia - montoAceptadoArancelTransferencia) === 0)) ?
                                                                                        <Alert style={{ width: '15rem' }} variant="outlined"
                                                                                            /* icon={<CheckIcon fontSize="inherit" />} */
                                                                                            iconMapping={{
                                                                                                info: <CheckCircleOutline fontSize="inherit" />,
                                                                                            }}
                                                                                            severity="info">Arancel Pagado</Alert>
                                                                                        :
                                                                                        ""
                                                                                }
                                                                            </div>
                                                                    }

                                                                </div>
                                                                {
                                                                    !btnArancel ?
                                                                        errorTransbank ?
                                                                            !tieneExcepcion ?
                                                                                <div>
                                                                                    <br /><br />
                                                                                    <a onClick={() => InsertarExcepcion()} style={{ cursor: 'pointer' }} className="enrollment__back"><svg className="svg-chevron-left-dims"><use xlinkHref={d1 + "#chevron-right"}></use></svg> Cambiar a pago por Transferencia Bancaria</a>
                                                                                </div>
                                                                                :
                                                                                ""
                                                                            :
                                                                            ""
                                                                        :
                                                                        ""
                                                                }
                                                            </div>
                                                        )
                                                    }
                                                } else if (e.formaPago === con.codTransferencia()) {
                                                    if (e.montoClp > 0) {
                                                        return (
                                                            <div className="">
                                                                {/* !btnArancelTB &&  */((montoArancelTransferencia - montoAceptadoArancelTransferencia) > 0) ?
                                                                    <div className="payment-webpay__summary">
                                                                        <table className="payment-webpay__table table">
                                                                            <thead>
                                                                                <tr>
                                                                                    {
                                                                                        montoPagoContado > 0 ?
                                                                                            <>
                                                                                                <th className="payment-webpay__item-title">Valor en pesos (CLP)</th>
                                                                                                <th className="payment-webpay__item-title">Descuento pago al contado (CLP)</th>
                                                                                            </>
                                                                                            :
                                                                                            ""
                                                                                    }

                                                                                    <th className="payment-webpay__item-title">A pagar (CLP)</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    {
                                                                                        montoPagoContado > 0 ?
                                                                                            <>
                                                                                                <td className="payment-webpay__item" data-th="Valor en pesos (CLP)"><span className="payment-webpay__item-value">$ {transformarMiles((Math.round(e.montoClp) + montoPagoContado).toString())}</span></td>
                                                                                                <td className="payment-webpay__item" data-th="Descuento pago al contado (CLP)"><span className="payment-webpay__item-value">{`$${transformarMiles(montoPagoContado.toString())}`}</span></td>
                                                                                            </>
                                                                                            :
                                                                                            ""
                                                                                    }
                                                                                    <td className="payment-webpay__item" data-th="A pagar (CLP)"><span className="payment-webpay__item-value">$ {transformarMiles(Math.round(e.montoClp).toString())}</span></td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                                                        {
                                                                            subiendoDocArancel ?
                                                                                <div style={{ display: 'contents' }}>
                                                                                    <CircularProgress disableShrink size={30} /> <p style={{ marginTop: 10 }}> &nbsp;&nbsp;&nbsp;&nbsp;Subiendo Comprobante</p>
                                                                                </div>
                                                                                :
                                                                                <div className="file-select" id="src-file1">

                                                                                    <input
                                                                                        aria-label="Archivo"
                                                                                        type="file"
                                                                                        style={{ width: '100%', fontSize: '1rem', cursor: 'pointer' }}
                                                                                        onChange={handleFileInputChangeArancel}
                                                                                    />

                                                                                </div>
                                                                        }
                                                                        {
                                                                            errorSubirDocArancel ?
                                                                                <>
                                                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                                                    <Alert variant="outlined" severity="error"> {mnsjSubirDocArancel} </Alert>
                                                                                </>
                                                                                :
                                                                                ""
                                                                        }

                                                                    </div>
                                                                    : ""}
                                                                <br />
                                                                <div className="payment-webpay__action">
                                                                    <div style={{ float: 'right' }}></div>
                                                                    {
                                                                        sumaTransferenciasArancel > 0 ?
                                                                            <table className={"payment-selection__table table"}>
                                                                                <thead>
                                                                                    <th className='text-center'>Valor total</th>
                                                                                    <th className='text-center'>Valor transferido</th>
                                                                                    <th className='text-center'>Saldo faltante</th>
                                                                                </thead>
                                                                                <tfoot>
                                                                                    <tr>
                                                                                        <td className='text-center'>{`$${transformarMiles((montoArancelTransferencia).toString())}`}</td>
                                                                                        <td className='text-center'>{`$${transformarMiles(sumaTransferenciasArancel.toString())}`}</td>
                                                                                        <td className='text-center'>{`$${transformarMiles(((montoArancelTransferencia) - sumaTransferenciasArancel).toString())}`}</td>
                                                                                    </tr>
                                                                                </tfoot>
                                                                            </table>
                                                                            :
                                                                            ""
                                                                    }

                                                                    {/* <button style={{ background: '#ab4343', border: '1px solid #ab4343', float: 'right' }} onClick={() => setOpenModalEliminarArancel(true)} hidden={!estadoRechazadoArancel} className="btn btn-primary" id="btn-submit-enrollment-tariff" type="submit">Eliminar Comprobantes</button> */}
                                                                    <Grid container item xs={12} sm={12} md={12} direction="column" >
                                                                        <CardContent>
                                                                            <Grid container direction="row">
                                                                                {listadoComprobanteArancel.map((e: IViewComprobanteListado, i: any) => {
                                                                                    return (
                                                                                        <div className={"rounded"} style={{ border: "1px solid #0062a1", padding: 20, marginBottom: 10, marginRight: 10, backgroundColor: 'rgb(246 251 255)' }}>
                                                                                            <Grid item xs={6} sm={6} md={6} direction="column">
                                                                                                <p className="" style={{ inlineSize: 'fit-content', width: '15rem' }}>
                                                                                                    <h4 className="card-title text-center font-weight-bold noWrap" style={{ height: 50 }}>{e.nombreEstado}</h4>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-left font-weight-normal">Rut: </span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{`${e.rutTitular}-${e.dvTitular}`}</strong></span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal">Nombre</span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{e.nombreTitular}</strong></span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal">N° Transacción</span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{e.numTransaccion}</strong></span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal">Banco</span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{e.nombreBanco}</strong></span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal">Tipo Cuenta</span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{e.nombreTipoCuenta}</strong></span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal">Monto</span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{`$${transformarMiles(e.montoPagado.toString())}`}</strong></span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal">Observación</span>
                                                                                                    <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><strong>{e.observacion === "" ? "-" : e.observacion}</strong></span>
                                                                                                    <br></br>
                                                                                                    {/* <br></br>
                                                                                                    <span style={{ fontSize: '1rem' }} className="card-text text-center font-weight-normal"><button onClick={() => handleVerDocumento(e.guidHQB)} className="btn btn-primary" id="btn-submit-enrollment-tariff" type="submit">Ver Adjunto</button></span>
                                                                                                    <br></br> */}
                                                                                                    {
                                                                                                        e.idEstado != 2 ?
                                                                                                            <span style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                                                                                                                <button
                                                                                                                    style={{ background: '#0062a1', border: '1px solid #0062a1', width: '7rem' }}
                                                                                                                    onClick={() => {
                                                                                                                        setIdProcesoItemPago(e.idProcesoItemPago)
                                                                                                                        setIdComprobante(e.idTransferencia)
                                                                                                                        setTimeout(() => {
                                                                                                                            setOpenModalArchivos(true)
                                                                                                                        }, 1000)
                                                                                                                    }}
                                                                                                                    className="btn btn-primary"
                                                                                                                    id="btn-submit-enrollment-tariff"
                                                                                                                    type="submit"><Edit fontSize="inherit" />Editar
                                                                                                                </button>

                                                                                                                <button
                                                                                                                    style={{ background: '#ab4343', border: '1px solid #ab4343', width: '7rem' }}
                                                                                                                    onClick={() => {
                                                                                                                        setIdComprobante(e.idTransferencia)
                                                                                                                        setOpenModalEliminarArancel(true)
                                                                                                                    }}
                                                                                                                    className="btn btn-primary"
                                                                                                                    id="btn-submit-enrollment-tariff"
                                                                                                                    type="submit"><Delete fontSize="inherit" />Eliminar
                                                                                                                </button>
                                                                                                            </span>
                                                                                                            :
                                                                                                            ""
                                                                                                    }
                                                                                                </p>
                                                                                            </Grid>
                                                                                        </div>
                                                                                    )
                                                                                }
                                                                                )
                                                                                }
                                                                            </Grid>
                                                                        </CardContent>
                                                                    </Grid>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                }
                                            }
                                        })}
                                        {
                                            btnArancel && (btnArancelTB && ((montoArancelTransferencia - montoAceptadoArancelTransferencia) === 0)) && btnMatricula && (btnMatriculaTB && ((montoMatriculaTransferencia - montoAceptadoMatriculaTransferencia) === 0)) ?
                                                <>
                                                    <br />
                                                    <br />
                                                    <Alert variant="outlined"
                                                        /* icon={<CheckIcon fontSize="inherit" />} */
                                                        iconMapping={{
                                                            info: <CheckCircleOutline fontSize="inherit" />,
                                                        }}
                                                        severity="info">La etapa se ha completado exitosamente. Por favor presionar botón CONTINUAR</Alert>
                                                </>
                                                :
                                                ""
                                        }
                                    </div>


                                </div>
                                <div className="payment-webpay__submit">
                                    <div className="form-group">
                                        <a onClick={() => onClickContinuar("3")} style={{ cursor: 'pointer' }} className="enrollment__back"><svg className="svg-chevron-left-dims"><use xlinkHref={d1 + "#chevron-left"}></use></svg> Volver a Forma de Pago</a>
                                        <label className="submit-btn__label-disabled">{debeFirmar ? "Ir a la Carga de Documentos" : "Finalizar Proceso "}</label>
                                        <button onClick={() => UpdateEtapaProceso()} disabled={btnArancel && btnMatricula && (btnMatriculaTB && ((montoMatriculaTransferencia - montoAceptadoMatriculaTransferencia) === 0)) && (btnArancelTB && ((montoArancelTransferencia - montoAceptadoArancelTransferencia) === 0)) ? false : true} className="btn btn-primary" id="btn-submit-enrollment-tariff" type="submit">Continuar</button>
                                    </div>
                                </div>
                                <Dialog open={openModal}
                                    onClose={() => setOpenModal(false)}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            {
                                                resultPago.length > 0 ?
                                                    resultPago[0].status === 'AUTHORIZED' ?
                                                        <div style={{ textAlign: 'center', padding: 20 }}>
                                                            <CheckCircleOutline style={{ fontSize: 100, color: 'green' }} />
                                                            <br />
                                                            <h4><span>Pago realizado exitosamente.</span></h4>
                                                            {/* <p>{resultPago[0].ResponseDescription}</p> */}
                                                            <br />
                                                            <h5><span>Detalle: </span></h5>
                                                            <p>Monto: ${transformarMiles(resultPago[0].amount.toString())}</p>
                                                            <p>Número de Orden: {resultPago[0].buyOrden}</p>
                                                            <p>Código de Autorización: {resultPago[0].authorizationCode}</p>
                                                            <p>Fecha de Transacción: {onFormatFate(resultPago[0].transactionDate.toString())}</p>
                                                        </div>
                                                        :
                                                        <div style={{ textAlign: 'center', padding: 20 }}>
                                                            <ErrorOutlineRounded style={{ fontSize: 100, color: 'red' }} />
                                                            <br />
                                                            <h3><span>Ocurrió un error al realizar el pago.</span></h3>
                                                            <p>Error: {resultPago[0].ResponseDescription}</p>
                                                            <br />
                                                            <h5><span>Detalle: </span></h5>
                                                            <p>Monto: ${transformarMiles(resultPago[0].amount.toString())}</p>
                                                            <p>Número de Orden: {resultPago[0].buyOrden}</p>
                                                            <p>Fecha de Transacción: {onFormatFate(resultPago[0].transactionDate.toString())}</p>
                                                        </div>
                                                    :
                                                    <div style={{ textAlign: 'center', padding: 20 }}>
                                                        <ErrorOutlineRounded style={{ fontSize: 100, color: 'red' }} />
                                                        <br />
                                                        <h3><span>Se ha cerrado la pestaña sin finalizar el pago.</span></h3>
                                                        <br />
                                                    </div>
                                            }
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            let _tt = JSON.stringify(location.state);
                                            let _params = JSON.parse(_tt)
                                            setOpenModal(false)
                                            setPagandoMatricula(false)
                                            setPagandoArancel(false)
                                            ObtieneProcesoItemPagoLogic(selObtenerFormaPago, _params.headers, idProcesoPostulante)
                                        }} color="primary" >Salir</Button>
                                    </DialogActions>
                                </Dialog>
                                <Dialog open={pagandoMatricula}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            {
                                                <div style={{ textAlign: 'center', padding: 20 }}>
                                                    <CircularProgress disableShrink />
                                                    <br />
                                                    <br />
                                                    <h4><span>Realizando pago Matrícula.</span></h4>
                                                    <br />
                                                </div>
                                            }
                                        </div>
                                    </DialogContent>
                                </Dialog>
                                <Dialog open={pagandoArancel}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            {
                                                <div style={{ textAlign: 'center', padding: 20 }}>
                                                    <CircularProgress disableShrink />
                                                    <br />
                                                    <br />
                                                    <h4><span>Realizando pago Arancel.</span></h4>
                                                    <br />
                                                </div>
                                            }
                                        </div>
                                    </DialogContent>
                                </Dialog>
                                <InfoComprobantes idProcesoItemPago={idProcesoItemPago} idComprobante={idComprobante} guid={guidComprobante} openModalArchivos={openModalArchivos} bancos={bancos} cuentas={cuentas} onClickModal={onClickModal} saldoFaltante={Math.round(saldoFaltante)}></InfoComprobantes>
                                <Dialog open={openModalEliminarMatricula}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            ¿ Está seguro de eliminar estos comprobantes ?
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            handleDeleteMatricula()
                                        }} color="primary" >Si</Button>
                                        <Button autoFocus onClick={() => {
                                            setOpenModalEliminarMatricula(false)
                                        }} color="primary" >No</Button>
                                    </DialogActions>
                                </Dialog>
                                <Dialog open={openModalEliminarArancel}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            ¿ Está seguro de eliminar estos comprobantes ?
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            handleDeleteArancel()
                                        }} color="primary" >Si</Button>
                                        <Button autoFocus onClick={() => {
                                            setOpenModalEliminarArancel(false)
                                        }} color="primary" >No</Button>
                                    </DialogActions>
                                </Dialog>
                                <Dialog open={errorVentanasEmergentes}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            {
                                                <div style={{ textAlign: 'center', padding: 20 }}>
                                                    <ErrorOutlineRounded style={{ fontSize: 100, color: 'red' }} />
                                                    <br />
                                                    <br />
                                                    <h4><span>Ventanas emergentes bloqueadas.</span></h4>
                                                    <br />
                                                    <a href="https://support.google.com/chrome/answer/95472?hl=es&co=GENIE.Platform%3DDesktop&oco=0" target="_blank">¿ Como resolverlo ?</a>
                                                </div>
                                            }
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            refrescar();
                                            //window.location.reload()
                                        }} color="primary" >Salir</Button>
                                    </DialogActions>
                                </Dialog>
                                <Panel
                                    isOpen={openCuentasTransferencias}
                                    type={PanelType.medium}
                                    hasCloseButton={true}
                                    onDismiss={() => { setOpenCuentasTransferencias(false) }}
                                >
                                    {/* <Dialog open={openCuentasTransferencias}
                                        onClose={() => setOpenCuentasTransferencias(false)}
                                        maxWidth={"xl"}
                                        aria-labelledby="draggable-dialog-title"> */}
                                    <DialogContent>
                                        <div style={{ textAlign: 'left', padding: 20 }}>

                                            <h5><span>Los datos son: </span></h5>
                                            <Grid container spacing={0} item xs={12}>
                                                <Grid item xs={4}>
                                                    <br></br>
                                                    {/* <p>Autorizado Matricularse: </p> */}
                                                    <p><b>Nombre </b></p>
                                                    <p><b>Rut </b></p>
                                                    <p><b>Correo </b></p>
                                                    <Divider></Divider>
                                                    <br></br>
                                                    <p><b>Banco </b></p>
                                                    <p><b>Tipo de cuenta </b></p>
                                                    <p><b>N° de cuenta </b></p>
                                                    <p><b>Asunto</b></p>
                                                    <p><br></br></p>

                                                </Grid>
                                                <Grid item xs={7}>
                                                    <br></br>
                                                    <p>Universidad del Desarrollo</p>
                                                    <p>71.644.300-0</p>
                                                    <p>contactotesoreria@udd.cl</p>
                                                    <Divider></Divider>
                                                    <br></br>
                                                    <p>Santander </p>
                                                    <p>Cuenta corriente</p>
                                                    <p>2599604-6</p>
                                                    <p>Indicar nombre y RUT del alumno, nombre y RUT de quien transfiere.</p>
                                                    <br></br>
                                                </Grid>
                                            </Grid>
                                            <p><b>Nota:</b> Una vez se haya adjuntado el/los comprobantes, debe ser validado por la Universidad
                                                dentro del día. Por favor revisar estado en línea para poder continuar el proceso
                                                (PENDIENTE: en revisión; RECHAZADO: documento no legible o monto incorrecto;
                                                APROBADO: monto correcto y autorizado)</p>
                                        </div>
                                    </DialogContent>
                                    <br />
                                    <br />
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            setOpenCuentasTransferencias(false)
                                        }} color="primary" >Cerrar</Button>
                                    </DialogActions>
                                </Panel>
                                <Dialog open={errorDoc}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            No se encontró el documento en el respositorio.
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            setErrorDoc(false)
                                        }} color="primary" >Salir</Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={transDelete}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            Transferencia eliminada correctamente.
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            setTransDelete(false);
                                            /* window.location.reload(); */
                                        }} color="primary" >Aceptar</Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={openCodComercioMatricula}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'left' }}>
                                            <h3>Seleccionar código de comercio</h3>
                                            {
                                                <div style={{ textAlign: 'left', padding: 20 }}>
                                                    <FormControl component="fieldset">
                                                        <RadioGroup
                                                            aria-label="gender"
                                                            name="controlled-radio-buttons-group1"
                                                            value={codComercioMatricula}
                                                            onChange={(e: any, i: any) => {
                                                                //setCodComercio(parseInt(i))
                                                                setCodComercioMatricula(parseInt(i))
                                                                console.log(i)
                                                            }}
                                                        >
                                                            {
                                                                listaComercioMatricula.map((e: IViewComercio) => {
                                                                    return (
                                                                        <div style={{ display: 'block' }}>
                                                                            {
                                                                                <p >
                                                                                    <span><FormControlLabel value={e.codComercio} control={<Radio color="primary" />} label="" /><label >{`${e.descripcion}`}</label></span>

                                                                                </p>
                                                                            }
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </RadioGroup>
                                                    </FormControl>
                                                </div>
                                            }
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            setPagar(true)
                                            setOpenCodComercioMatricula(false)
                                        }} color="primary" >Seleccionar</Button>
                                        <Button autoFocus onClick={() => {
                                            setOpenCodComercioMatricula(false)
                                        }} color="primary" >Salir</Button>
                                    </DialogActions>
                                </Dialog>
                                <Dialog open={openCodComercioArancel}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'left' }}>
                                            <h3>Seleccionar código de comercio</h3>
                                            {
                                                <div style={{ textAlign: 'left', padding: 20 }}>
                                                    <FormControl component="fieldset">
                                                        <RadioGroup
                                                            aria-label="gender"
                                                            name="controlled-radio-buttons-group1"
                                                            value={codComercioArancel}
                                                            onChange={(e: any, i: any) => {
                                                                //setCodComercio(parseInt(i))
                                                                setCodComercioArancel(parseInt(i))
                                                                console.log(i)
                                                            }}
                                                        >
                                                            {
                                                                listaComercioArancel.map((e: IViewComercio) => {
                                                                    return (
                                                                        <div style={{ display: 'block' }}>
                                                                            {
                                                                                <p >
                                                                                    <span><FormControlLabel value={e.codComercio} control={<Radio color="primary" />} label="" /><label >{`${e.descripcion}`}</label></span>

                                                                                </p>
                                                                            }
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </RadioGroup>
                                                    </FormControl>
                                                </div>
                                            }
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            setPagar(true)
                                            setOpenCodComercioArancel(false)
                                        }} color="primary" >Seleccionar</Button>
                                        <Button autoFocus onClick={() => {
                                            setOpenCodComercioArancel(false)
                                        }} color="primary" >Salir</Button>
                                    </DialogActions>
                                </Dialog>
                            </div>}
                    </main>}
            {
                openModalToken.open ?
                    <MensajeToken mnsj={openModalToken.mnsj} codNegocio={codNegocio}></MensajeToken>
                    :
                    ""
            }
        </>
    )
}
